import { CardModel } from "../../_shared/lottoloca-commom/lottery-modex";
import { DbLotteryCardModel } from "./db-lottery-card-model";
import { ICollectionReference } from '../database-cast/IDatabase';


export class DbLotteryCardModels {


  getData(): Promise<CardModel[]> {
  
    let promise: Promise<CardModel[]> = new Promise((resolve, reject) => {

        this._collection
            .get()
            .then((querySnapshot: any) => {

                let cardModels: Array<any> = [];
                querySnapshot.forEach(doc => {
                    let cardModel = doc.data();

                    cardModel.id = doc.id;

                    cardModels.push(cardModel);
                });


                resolve(cardModels);

            })
            .catch(error => {
                reject(error);
            });


    });


    return promise;

  }


    private _collection: ICollectionReference;

    constructor(collection: ICollectionReference) {
        this._collection = collection;
    }

    public add(value: CardModel): Promise<CardModel> {

        console.log("Adiconando modelo...")

        let obj =JSON.parse( JSON.stringify(value));

        let promise = new Promise<CardModel>((resolve, reject) => {
            this._collection.add(obj)
                .then(docReference => {

                    resolve(value);
                }).
                catch(error => {
                    reject(error);

                });
        });


        return promise;
    }

    
 public  getCardModel(id: string): DbLotteryCardModel {
    return new DbLotteryCardModel(id,this._collection);
  }


}